<template>
    <div class="content-header container">
        <h1 class="content-header__title">{{ title }}</h1>
        <ul class="routes">
            <li>
                <router-link :to="{name: 'Home'}"
                             title="Просмотреть все посты в Праздник">Главная
                </router-link>
                <div class="separator ">
                    &nbsp;
                </div>
            </li>
            <li>
                <router-link :to="{name: $route.name}"
                             title="Просмотреть все посты в Праздник">{{ $route.name }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ["title"]
}
</script>

<style scoped lang="scss">
.content-header {
    padding: 20px 0;
    display: flex;
    padding-top: 30px;
    flex-wrap: wrap;
    align-items: center;
    border-bottom: 1px solid #E8E8E8;

    &__title {
        margin-right: 20px;
        max-width: 800px;
        text-align: left;
    }

    &__routes {
        display: flex;

        li {
            font-size: 11px;
            color: #909090;
            margin-right: 5px;
            display: flex;
            align-items: center;
            cursor: pointer;

            a {
                color: #909090;
                text-decoration: underline;
            }

            a:not(:last-child) {

            }
        }

        li:last-child {
            .separator {
                display: none;
            }

            margin-right: 0;
        }
    }

}

@media screen and (max-width: 968px) {
    .content-header {
        width: 100%;
    }
}

@media screen and (max-width: 768px) {
    .content-header {

        &__title {
            font-size: 23px;
        }
    }

}

.separator {
    background-repeat: no-repeat;
    background-image: url(http://staging-5-clinic.ru/wp-content/themes/medicenter/images/icon_arrow_right_gray.png);
    font-size: 11px;
    margin-left: 3px;
    width: 8px;
    height: 5px;
    padding: 0 4px;
}

</style>